import { Avatar, Grid, TextareaAutosize } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import { Room } from '@material-ui/icons';
import { getInfosDashboard } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import theme from '../theme'

const {
  colors: { addressColor, background },
} = theme;

const StudentCard = ({ student, setSelectedStudent }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { data: dashboardInfo = {} } = useQuery(getInfosDashboard, {
    key: ['infoDashboardBusiness', student.id],
    variables: { id: student.id },
  });

  const profileImage = dashboardInfo?.profile?.profileImageUrl;

  return (
    <Paper className={classes.cardContainer} elevation={0}>
      <CardContent
        className={css({ textAlign: 'center', padding: spacing(0, 0, 1, 0) })}
      >
        <div
          className={css({ display: 'flex', justifyContent: 'space-between' })}
        >
          <div className={classes.photo}>
            <div>
              <div>
                {profileImage ? (
                  <Avatar className={classes.avatar} src={profileImage} />
                ) : (
                  <Avatar className={classes.avatar}>
                    {`${student?.lastname?.substr(0, 1)} ${student?.firstname?.substr(0, 1)}`}
                  </Avatar>
                )}
              </div>
            </div>
            <Grid
              className={css({
                fontWeight: 600,
                color: '#000',
              })}
            >
              <div
                className={cx(css({
                  marginLeft: spacing(2),
                  display: 'flex',
                  textAlign: 'start',
                  wordBreak: 'break-all',
                }), global.title)}
              >
                {`${student?.firstname} ${student?.lastname}`} 
              </div>
              <div
                className={cx(css({
                  display: 'flex',
                  marginLeft: spacing(1.5),
                  marginTop: spacing(1),
                  textAlign: 'start',
                  alignItems: 'center',
                }), global.infoText)}
              >
                <Room className={global.infoIcon} />{' '}
                {student?.address?.cityCode} {student?.address?.city}
              </div>
            </Grid>
          </div>
        </div>
      </CardContent>
      <div className={classes.buttons}>
        <Button
          onClick={() => setSelectedStudent(student)}
          style={{ fontWeight: 600 }}
          variant="outlined"
        >
          Voir le CV
        </Button>
      </div>
    </Paper>
  );
};

StudentCard.propTypes = {
  student: PropTypes.object,
  setSelectedStudent: PropTypes.func,
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: spacing(2.5),
    marginTop: spacing(3),
  },
  avatar: {
    height: 70,
    width: 70,
    border: '1px solid #C0D9FF',
  },
  cardContainer: {
    borderRadius: 10,
    padding: spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
  },
  photo: {
    marginBottom: spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 20,
    marginTop: 'auto',
  },
});

export default StudentCard;
